import React from 'react';
import { BrowserRouter as Router, Route, Routes } from 'react-router-dom';
import Landingpage from './components/Landingpage';
import Header from './components/Header';
import Footer from './components/Footer';
import CursorFollower from './components/CursorFollower';
import WhatsAppButton from './components/WhatsAppButton';
import Motorization from './components/Motorization';
import RoomBrightening from './components/RoomBrightening';
import LightEnhancing from './components/LightEnhancing';
import RoomDarkeningShades from './components/RoomDarkeningShades';
import RollerShades from './components/Shades/RollerShades';
import SheerShades from './components/Shades/SheerShades';
import VerticalShades from './components/Shades/VerticalShades';
import WovenShades from './components/Shades/WovenShades';
import RomanShades from './components/Shades/RomanShades';
import AuraIlluminatedShadesPage from './components/Shades/AuraIlluminatedShadesPage';
import EnergyEfficientShades from './components/EnergyEfficientShades';
import RollerBlinds from './components/Blinds/RollerBlinds';
import ShangriLa from './components/Blinds/ShangriLa';
import TripleShade from './components/Blinds/TripleShade';
import WoodenBlinds from './components/Blinds/WoodenBlinds';
import ZebreBlinds from './components/Blinds/ZebreBlinds';
import ContactUs from './components/ContactUs';
import ScrollToTop from './components/ScrollToTop';
import FaqComponent from './components/FaqComponent';
import Catelogs from './components/Catelogs';
import SEOComponent from './SEOComponent';

function App() {
  return (
    <Router>
      <SEOComponent/>
      <ScrollToTop /> 
      <Header />
      <Routes>
        <Route path="/" element={<Landingpage />} />
        <Route path="/motarization" element={<Motorization />} />
        <Route path="/contactus" element={<ContactUs />} />
        <Route path="/catelogs" element={<Catelogs />} />


        {/* browse by need components */}
        <Route path="/roombright" element={<RoomBrightening />} />
        <Route path="/lightenhancing" element={<LightEnhancing />} />
        <Route path="/roomdarkening" element={<RoomDarkeningShades />} />
        <Route path="/energyefficient" element={<EnergyEfficientShades />} />


{/* shades components */}
        <Route path="/rollershades" element={<RollerShades />} />
        <Route path="/verticalshades" element={<VerticalShades />} />
        <Route path="/romanshades" element={<RomanShades />} />
        <Route path="/cellularshades" element={<RomanShades />} />
        <Route path="/aurashades" element={<AuraIlluminatedShadesPage />} />
        <Route path="/wovenshades" element={<WovenShades />} />
        <Route path="/sheershades" element={<SheerShades />} />


        {/* blinds components */}
        <Route path="/rollerblinds" element={<RollerBlinds />} />
        <Route path="/shangblinds" element={<ShangriLa />} />
        <Route path="/tripleblinds" element={<TripleShade />} />
        <Route path="/woodenblinds" element={<WoodenBlinds />} />
        <Route path="/zebreblinds" element={<ZebreBlinds />} />

        <Route path="/faqs" element={<FaqComponent />} />






      </Routes>
      <Footer />
      <WhatsAppButton />
    </Router>
  );
}

export default App;
